import React, { useContext } from "react";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuButton from "../Navbar/MenuButton";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import * as api from "../services";
import AppContext from "../appContext";
import MutationMessage from "../Components/MutationMessage";

export default function LogoutButton() {
  const {
    app: { sessionId },
  } = useContext(AppContext);
  const { t } = useTranslation();
  const logoutMutation = useMutation(() => api.unlockAll({ sessionId }), {
    onSuccess: () => {
      window.location = `${window.REACT_APP_LOGOUT_ADDRESS}?sessionId=${sessionId}`;
    },
  });
  return (
    <div>
      <MutationMessage mutation={logoutMutation} />
      <MenuButton
        id="navBtnLogout"
        title={t("navigation.logout")}
        icon={<ExitToAppIcon />}
        paths={[]}
        func={() => logoutMutation.mutate()}
      />
    </div>
  );
}
